/**
 * Generic function for downloading file in de browser
 */
export const downloadFile = (file, fileName) => {
  let url = window.URL.createObjectURL(file);
  let a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  a.click();
};

export const isMobile = window.innerWidth <= 768;

export const isTablet = window.innerWidth > 768 && window.innerWidth <= 991;

export const getTop = (el) =>
  el.offsetTop + (el.offsetParent && getTop(el.offsetParent));

export const getSha256Hash = async (string) => {
  const msgUint8 = new TextEncoder().encode(string); // encode as (utf-8) Uint8Array
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", msgUint8); // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join(""); // convert bytes to hex string
  return hashHex;
};
